import { EnvironmentType } from "library/Apis";

declare global {
  interface Window {
    dataLayer: any[];
  }
}

export function initGTM() {
  const env = window.env as EnvironmentType;

  if (!env) return;

  if (env.environment !== 'production') {
    console.warn(`[GTM] Ambiente atual: ${env.environment}. GTM não será carregado.`);
    return;
  }

  const containerId = env.analytics?.gtmContainerId;
  if (!containerId) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'gtm.init', env: 'production' });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
  document.head.appendChild(script);
}

